// extracted by mini-css-extract-plugin
export var notificationHost = "_dz-0";